/**
 * ボタンをクリックしたらパスワードの表示・非表示を切り替える
 * @param {String} inputClassName input要素のクラスめい
 * @param {String} btnClassName ボタン要素のクラスめい
 */
export const togglePassword = (inputClassName, btnClassName) => {
  const input = document.querySelector(`.${inputClassName}`);
  const btn = document.querySelector(`.${btnClassName}`);
  btn.addEventListener('click', () => {
    if (input.type === 'password') {
      input.type = 'text';
      input.classList.add('js-toggle-password-show');
      btn.textContent = '非表示';
    } else {
      input.type = 'password';
      btn.textContent = '表示';
      input.classList.remove('js-toggle-password-show');
    }
  });
};
